
// src/hooks/SnackbarAlert.js
import React, { useState, useCallback } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

let showSnackbarGlobal;

export const SnackbarAlertProvider = ({ children }) => {
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const showSnackbar = useCallback((message, severity = "success") => {
    setSnack({ open: true, message, severity });
  }, []);

  showSnackbarGlobal = showSnackbar;

  const handleClose = () => {
    setSnack((prev) => ({ ...prev, open: false }));
  };

  return (
    <>
      {children}
      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleClose}
          severity={snack.severity} // "success" = green, "error" = red
          sx={{
            width: "100%",
            fontSize: "0.95rem",
            fontWeight: 500,
            borderRadius: "8px",
            boxShadow: "0px 3px 8px rgba(0,0,0,0.25)",
            color: "#fff", // text
            "& .MuiAlert-icon": {
              color: "#fff", // ✅ make icon white
            },
            ...(snack.severity === "error" && {
              backgroundColor: "#fc0707ff",
              color: "#fff",
            }), // Optional custom red
            ...(snack.severity === "success" && {
              backgroundColor: "#04710cff",
              color: "#fff",
            }), // Optional custom green
          }}
        >
          {snack.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default function SnackbarAlert(message, severity = "success") {
  if (showSnackbarGlobal) {
    showSnackbarGlobal(message, severity);
  } else {
    console.warn("⚠ SnackbarAlertProvider is not mounted yet");
  }
}
